var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmericanExpressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 0H2C0.89543 0 0 0.89543 0 2V14C0 15.1046 0.89543 16 2 16H22C23.1046 16 24 15.1046 24 14V2C24 0.89543 23.1046 0 22 0Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.764 13.3938V7.69238L23.9116 7.70149V9.27638L22.7387 10.5298L23.9116 11.7947V13.403H22.039L21.0438 12.3048L20.0557 13.4071L13.764 13.3938Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4418 12.7687V8.31982H18.2141V9.34471H15.6632V10.0404H18.1532V11.0482H15.6632V11.7315H18.2141V12.7687H14.4418Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1953 12.7686L20.2826 10.5416L18.1952 8.31982H19.8108L21.0863 9.72986L22.3654 8.31982H23.9116V8.35483L21.8687 10.5416L23.9116 12.7055V12.7686H22.3499L21.0518 11.3444L19.767 12.7686H18.1953Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2374 2.63184H16.6834L17.5426 4.58269V2.63184H20.5624L21.0832 4.09341L21.6057 2.63184H23.9116V8.33323H11.7251L14.2374 2.63184Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7005 3.25098L12.7264 7.69615H14.0803L14.4528 6.80598H16.4707L16.8429 7.69615H18.2304L16.2647 3.25098H14.7005ZM14.8701 5.80841L15.4621 4.39334L16.0536 5.80841H14.8701Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2119 7.69557V3.25049L20.115 3.25703L21.0943 5.98976L22.0799 3.25049H23.9115V7.69557L22.7329 7.706V4.65265L21.6204 7.69557H20.5446L19.4089 4.64222V7.69557H18.2119Z",
    fill: "#016FD0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpressIcon);
export default __webpack_public_path__ + "static/media/american-express-icon.a8535bc4099fce5e1784b8820c6ae2ac.svg";
export { ForwardRef as ReactComponent };